import styled from "styled-components";

const FooterContainer = styled.div`
  padding-top: 0px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
  color: #757575;
`;
export default FooterContainer;
